import { render, staticRenderFns } from "./TeacherPerformanceRecord.vue?vue&type=template&id=dec6ac92"
import script from "./TeacherPerformanceRecord.vue?vue&type=script&lang=js"
export * from "./TeacherPerformanceRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports